/*
 * @Author: liusuyun
 * @Date: 2021-09-27 20:51:10
 * @LastEditors: wuqinfa
 * @LastEditTime: 2024-02-20 16:42:12
 * @Description: 导入相关
 */
import { getImportRecord, getTemplate } from '@/services/importLog';

export default {
  namespace: 'importModal',
  state: {},
  effects: {
    *getTemplate({ payload }: any, { call }: any): any {
      const response = yield call(getTemplate, payload);
      return response;
    },
    *getImportRecord({ payload }: any, { call }: any): any {
      const response = yield call(getImportRecord, payload);
      // const { records = [], current = 1, size = 10, total = 0 } = response.data || {};
      return {
        data: response.data,
        success: true,
      };
    },
  },
};
